import { render, staticRenderFns } from "./SendMessageDialog.vue?vue&type=template&id=1a71c3b3&"
import script from "./SendMessageDialog.vue?vue&type=script&lang=js&"
export * from "./SendMessageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports